import axios from 'axios';
import store from '@/store';
import _ from 'lodash';
import UserService from './services/UserService';
import { getSigninUrl, isAuthLocation } from '@/Utils/authRedirect';

const axiosInstance = axios.create({
	baseURL: process.env.VUE_APP_APP_API_BASE,
	timeout: 30 * 1000,
	// withCredentials: true,
	config: {
		headers: {
			'content-type': 'application/json'
		}
	}
});

// Request interceptor:
axiosInstance.interceptors.request.use((request) => {
	if (request.url && request.url.includes('stats.castr.io')) {
		return request;
	}

	if (request.url && request.url.includes('global.ssl.fastly') || request.url.includes('fastlystorage')) {
		return request;
	}

	const token = UserService.getUserToken();
	if(token) {
		request.headers['auth-token'] = token;
	}

	return request;
}, (error) => {
	console.log('err', error)
	throw error;
});

// Response interceptor:
axiosInstance.interceptors.response.use((response) => response, async (error) => {
	if (_.get(error,'response.status') === 401) {
		const { href } = window.location;
		const onAuthPage = isAuthLocation(href);

		// On auth pages an a_token auto-login may be in flight. A stray 401 from a
		// racing bootstrap call must NOT log the user out (which wipes the token
		// SignIn.vue just applied) nor redirect — that's the reload loop. Let the
		// caller (tryAutoLogin) handle its own failure. Only clear the session and
		// bounce when we're on a real, authenticated page.
		if (!onAuthPage) {
			await store.dispatch('Auth/logout');
			console.log('auth redirect: status code 401');
			setTimeout(() => {
				window.location.href = getSigninUrl();
			});
			return;
		}
	}

	return Promise.reject(error);
});

export default axiosInstance;
